import { Button, Input, InputGroup, InputRightElement } from "@chakra-ui/react"
import { HTMLAttributes, useState } from "react"

interface IPropsPasswordInput {
    onChange: (date: any) => void
    value: string
}

function PasswordInput({
    onChange,
    value,
    ...props
}: IPropsPasswordInput & HTMLAttributes<HTMLElement>) {

    const [show, setShow] = useState(false)
    const handleClick = () => setShow(!show)

    return (
        <InputGroup size='md'>
            <Input
                pr='4.5rem'
                type={show ? 'text' : 'password'}
                placeholder='Clave'
                defaultValue={value}
                mt={1}
                onChange={onChange}
                name="password"
            />
            <InputRightElement width='4.5rem'>
                <Button
                    h='1.75rem'
                    size='sm'
                    onClick={handleClick}
                    colorScheme="brand"
                    mr={1}
                >
                    {show ? 'Ocultar' : 'Mostrar'}
                </Button>
            </InputRightElement>
        </InputGroup>
    )
}

export default PasswordInput